import React, { useState, useEffect, Suspense } from 'react';
import { FormContainer, FormBackground } from '../CreateForm.styles';
import { AuthCheckAdmin } from '../../../Utils/AuthCheck/AdminCheck.auth';
import CreateCompanySubmit from './CompanyCreateSubmit';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component';

const BreadCrumbs = React.lazy(
  () => import('../../../Components/Breadcrumbs/BreadcrumbsComponent.component')
);
const LogoInput = React.lazy(
  () => import('../../../Components/Form/LogoInput')
);
const AddressComponent = React.lazy(
  () => import('../../../Components/CompanyForm/Address')
);
const CompanyInfo = React.lazy(
  () => import('../../../Components/CompanyForm/CompanyInfo')
);
const ResultModal = React.lazy(
  () => import('../../../Components/Modal/ResultModal.component')
);

const CreateCompany = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [result, setResult] = useState('');
  const [image, setImage] = useState('');
  const [company, setCompany] = useState({
    companyName: '',
    mainContact: '',
    secondaryContact: '',
    email: '',
    phoneOffice: '',
    phoneMobile: '',
    website: '',
    notes: '',
    secondaryEmail: '',
    secondaryPhone: '',
    industry: '',
  });
  const [billingAddress, setBillingAddress] = useState({
    street: '',
    city: '',
    province: '',
    postalCode: '',
  });

  const [validForm, setValidForm] = useState(false);

  useEffect(() => {
    const checkFormValidity = () => {
      const isCompanyValid =
        company.companyName.trim() !== '' &&
        company.mainContact.trim() !== '' &&
        company.phoneOffice.trim() !== '';
      setValidForm(isCompanyValid);
    };
    checkFormValidity();
  }, [company]);

  return (
    <AuthCheckAdmin>
      <HelmetHelper
        title="Create Company"
        description="Create a company form"
      />
      <FormContainer>
        <Suspense fallback={<p>Loading breadcrumbs...</p>}>
          <BreadCrumbs
            one="Admin Dashboard"
            oneLink="/admin"
            two="Create Company"
          />
        </Suspense>
        <h2>CREATE COMPANY</h2>
        <form>
          <FormBackground>
            <Suspense fallback={<p>Loading company info...</p>}>
              <CompanyInfo company={company} setCompany={setCompany} />
            </Suspense>
            <Suspense fallback={<p>Loading address form...</p>}>
              <AddressComponent
                billingAddress={billingAddress}
                setBillingAddress={setBillingAddress}
              />
            </Suspense>
            <Suspense fallback={<p>Loading logo input...</p>}>
              <LogoInput
                image={image}
                setImage={setImage}
                containerClassName="formInputUnderline"
              />
            </Suspense>
            <Suspense fallback={<p>Loading result modal...</p>}>
              <ResultModal
                isOpen={isOpen}
                result={result}
                onClose={() => setIsOpen(false)}
                linkTo="/admin"
              />
            </Suspense>
          </FormBackground>

          <CreateCompanySubmit
            image={image}
            company={company}
            result={result}
            setIsOpen={setIsOpen}
            setResult={setResult}
            disabled={validForm}
            billingAddress={billingAddress}
          />
        </form>
      </FormContainer>
    </AuthCheckAdmin>
  );
};

export default CreateCompany;
